import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { CompetitionProvider } from './context/CompetitionContext'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import Setup from './pages/Setup'
import Timer from './pages/Timer'
import Help from './pages/Help'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <CompetitionProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/timer" element={<Timer />} />
          <Route path="/help" element={<Help />} />
        </Routes>
      </BrowserRouter>
    </CompetitionProvider>
  </React.StrictMode>,
)
